import { Box, BoxProps, Rating } from '@mui/material';
import StarIcon from '@components/Icon/Star';
import StarActiveIcon from '@components/Icon/StarActiveIcon';

type RatingSelectorProps = Pick<BoxProps, 'sx'> & {
    value?: number;
    size?: 'small' | 'large';
    onChange?: (value: number | null) => void;
    readOnly?: boolean;
};

export const RatingSelector = ({ value = 4, sx, size = 'small', onChange, readOnly = false }: RatingSelectorProps) => {
    return (
        <Box
            sx={{
                padding: size === 'small' ? '6px 8px' : '12px',
                borderRadius: '8px',
                alignSelf: 'flex-start',
                ...sx,
            }}>
            <Rating
                value={value}
                onChange={(event, newValue) => {
                    if (onChange && !readOnly) {
                        onChange(newValue);
                    }
                }}
                sx={{
                    color: '#ffd700',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',

                    '& .MuiRating-icon svg': {
                        width: size === 'small' ? 12 : 20,
                        height: size === 'small' ? 12 : 20,
                    },
                }}
                icon={<StarActiveIcon />}
                emptyIcon={<StarIcon />}
                readOnly={readOnly}
            />
        </Box>
    );
};
